import React from 'react';

import { IconProps } from '../Icon.types';

export const CircleOutlineIcon = ({ width, height, color }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="14" height="14" rx="7" fill="white" />
      <rect
        x="1"
        y="1"
        width="14"
        height="14"
        rx="7"
        stroke={color}
        stroke-width="2"
      />
    </svg>
  );
};
